import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import {
    CustomerDetailsCourseParticipation,
    TimeExpenditure,
} from '../../../../../../../shared/interfaces/src';
import { CustomerService } from '../../services/customer.service';
import * as _ from 'lodash';

@Component({
    selector: 'cna-customer-fao-reading-times',
    templateUrl: './customer-fao-reading-times.component.html',
    styleUrls: ['./customer-fao-reading-times.component.scss'],
})
export class CustomerFaoReadingTimesComponent implements OnInit {
    @Input()
    courseParticipation: CustomerDetailsCourseParticipation;
    @Input()
    timeExpenditures: TimeExpenditure[];

    constructor(private readonly customerService: CustomerService) {}

    faoTimeExpenditures$: Observable<
        {
            faoTitle: string;
            timeExpenditures: TimeExpenditure[];
            duration: number;
        }[]
    >;

    faoLoading$ = new BehaviorSubject<boolean>(false);

    protected readonly takeUntil = takeUntil;

    ngOnInit(): void {
        this.faoLoading$.next(true);
        const sortedModules = [
            ...this.courseParticipation.bookedCourse.modules,
        ].sort((m1, m2) => m1.sequentialNumber - m2.sequentialNumber);
        this.faoTimeExpenditures$ = this.customerService
            .getFaoTimeExpenditures(
                this.courseParticipation.id,
                sortedModules.map(module => module.id),
                this.timeExpenditures
            )
            .pipe(tap(() => this.faoLoading$.next(false)));
    }
}
